module.exports = __webpack_public_path__ + "img/cake.3c75e366.svg";